import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button';

export const ErrorPage = ({
  showReportDialog,
  errorMessage,
}: {
  showReportDialog?: () => void;
  errorMessage?: ReactNode;
}) => (
  <div>
    <h4>{errorMessage || 'Seems like something went wrong.'}</h4>
    {showReportDialog && (
      <Button variant="default" size="lg" onClick={showReportDialog}>
        Send a report
      </Button>
    )}
  </div>
);

export default ErrorPage;
